import React, { useEffect } from 'react';
import { FieldValue, RegisterOptions, Validate } from 'react-hook-form';
import FormInputValidator from '@app/component/form/input/FormInputValidator';
import has from 'lodash/has';
import get from 'lodash/get';
import FormInputStyleProperties from '@app/component/form/input/FormInputStyleProperties';
import { useTranslation } from '@app/component/translation/Translation';
import moment from 'moment';

import FormSelect from '@app/component/form/input/select/FormSelect';

type Props = {
	isRequired?: boolean,
	placeholder?: string,
	form?: any,
	name: string,
	label?: string,
	labelHint?: React.JSX.Element,
	disabled?: boolean,
	validation?: FormInputValidator | Validate<any, FieldValue<any>>,
	hideErrorMessage?: boolean
} & FormInputStyleProperties;


const FormInputDatePicker: React.FunctionComponent<Props> = (
	{
		form,
		placeholder,
		name,
		isRequired = false,
		label,
		isLoading,
		disabled = false,
		labelHint,
		validation,
		hideErrorMessage = false,
	}) => {

	const { t } = useTranslation('common.form.error');
	const hasError = !!form && has(form.formState.errors, name);
	const errorMessage = hasError ? (get(form.formState.errors, name + '.message') || t('required')) : '';

	useEffect(() => {
		if (!disabled) {
			const options: Partial<RegisterOptions> = {
				required: isRequired,
			};
			if (!!validation) {
				if (typeof validation === 'function') {
					options.validate = validation;
				} else if (typeof validation === 'object') {
					options.validate = {
						checkUrl: (value) => {
							return (validation as FormInputValidator).check(value);
						},
					};
				}
			}
			form.register(name, options);
		}
	}, []);


	const value = form.watch(name);

	if (!value) form.setValue(name, moment().format('HH:mm'));


	const options = () => {
		const options = [];
		for (let i = 0; i < 24; i++) {
			options.push({
				label: (i < 10 ? '0' + i : i) + ':00',
				value: (i < 10 ? '0' + i : i) + ':00:00',
				id: (i < 10 ? '0' + i : i) + '_00',
			});
			options.push({
				label: (i < 10 ? '0' + i : i) + ':30',
				value: (i < 10 ? '0' + i : i) + ':30:00',
				id: (i < 10 ? '0' + i : i) + '_30',
			});

		}
		return options;
	};

	const renderField = () => {
		return <>
			{!!form && <FormSelect form={form} name={name} disabled={disabled} options={options()} placeholder="Select Time"/>}
		</>;
	};

	return <div>
		{!!label && <div className="label">{label}</div>}
		{!!labelHint ? labelHint : ''}
		{renderField()}
		{!!errorMessage && !hideErrorMessage && <p className="help help-error">{errorMessage}</p>}
	</div>;

};

export default FormInputDatePicker;